import { useEffect, useState } from 'react';
import { put } from 'helpers/apiHelpers';
import { compose } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { fetchBrandConfigModulesPack } from 'actions/Brands';
import { combineStyles } from 'helpers/helpers';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';
import { toast } from 'react-toastify';

import ShopMeals from './ShopMeals';
import DishDetails from './DishDetails';
import OtherConfiguration from './OtherConfiguration';
import ClientPanel from './ClientPanel';

const Shop = ({ classes }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedBrand = useSelector(state => state.Auth.selectedBrand);
  const [shopModule, setShopModule] = useState({});
  const [configClientPanelModule, setConfigClientPanelModule] = useState({});

  useEffect(() => {
    dispatch(
      fetchBrandConfigModulesPack(selectedBrand, ['Shop', 'ConfigClientPanel'])
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    ).then(response => {
      const {
        '@id': idIri,
        '@type': typeIri,
        ...restShopVariables
      } = response.configuration.Shop;
      const {
        '@id': idCcpIri,
        '@type': typeCcpIri,
        ...restConfigClientPanelVariables
      } = response.configuration.ConfigClientPanel;

      setShopModule(restShopVariables);
      setConfigClientPanelModule(restConfigClientPanelVariables);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleSubmit = () => {
    put(`/brands/${selectedBrand}/modules`, {
      configuration: {
        ConfigClientPanel: configClientPanelModule,
        Shop: shopModule,
      },
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(() => {
      toast.success(t('success.dataUpdated'));
    });
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <ShopMeals
        classes={classes}
        shopModule={shopModule}
        setShopModule={setShopModule}
      />
      <DishDetails
        classes={classes}
        shopModule={shopModule}
        setShopModule={setShopModule}
      />
      <OtherConfiguration
        shopModule={shopModule}
        setShopModule={setShopModule}
      />
      <ClientPanel shopModule={shopModule} setShopModule={setShopModule} />
      <FormControlStickyButton
        classes={classes}
        secondarySubmitText={t('form.save')}
        handleSecondarySubmit={e => handleSubmit(e, false)}
      />
    </div>
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(withStyles(combinedStyles));

export default enhance(Shop);
